'use client';

import { c as _c } from "react/compiler-runtime";
import { BackupStatus, ConfigurationStatus, type InventoryResource } from '@repo/api-gw-sdk';
import { useCallback } from 'react';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';

/**
 * Whether a resource is still waiting on its first scan, which hides the fields that scan
 * fills in. Reads the configuration status when `InventoryStatusColumns` is on and the backup
 * status otherwise.
 */
export const useIsInitialClassification = () => {
  const $ = _c(2);
  const {
    InventoryStatusColumns
  } = useFeatureFlags();
  let t0;
  if ($[0] !== InventoryStatusColumns) {
    t0 = resource => InventoryStatusColumns ? resource.configurationStatus === ConfigurationStatus.CONFIGURATION_STATUS_INITIAL_CLASSIFICATION : resource.backupStatus === BackupStatus.InitialClassification;
    $[0] = InventoryStatusColumns;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};